import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import ThemeWrapper from "./components/themeWrapper";
import { DarkModeProvider } from "./components/context/darkModeContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DarkModeProvider>
      <ThemeWrapper>
        <App />
      </ThemeWrapper>
    </DarkModeProvider>
  </React.StrictMode>
);
